export default "__VITE_ASSET__ec8395d3__"